// LIBRARIES //
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { AntdButton } from '@yuhuinc/ui-library';
import { WarningFilled, Loading3QuartersOutlined } from '@ant-design/icons';
import Lottie from 'react-lottie';

// COMPONENTS
import DrawerMessage from '../DrawerMessage';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import { iconColors } from 'helpers/ColorHelper';
import successAnimationData from 'assets/success.json';
import { primaryButtonColors, buttonColors } from '../ButtonColors';

// ACTIONS //
import { optOutLead, optInLead, getTenant, deleteCotenant } from 'actions/landlordTenantsActions';
import { hideDeleteDrawer, setLoading, closeResidentDrawer } from '../store/actions';

const StyledWarning = styled(WarningFilled)`
  font-size: 40px;
  color: ${iconColors.WARNING_FILLED};
`;

const StyledLoading = styled(Loading3QuartersOutlined)`
  font-size: 40px;
  color: ${iconColors.LOADING_OUTLINED};
`;

const BodyText = styled.div`
  font-size: 16px;
  margin-left: 137px;
  margin-right: 137px;
`;

const successOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const deleteData = {
  headerImageSource: <StyledWarning />,
  headerText: getTranslatedString('residentDrawer.deleteDrawer.title'),
  bodyText: <BodyText>{getTranslatedString('residentDrawer.deleteDrawer.body')}</BodyText>,
};

const loadingData = {
  headerImageSource: <StyledLoading spin />,
  headerText: getTranslatedString('residentDrawer.loading.title'),
  bodyText: <BodyText>{getTranslatedString('residentDrawer.loading.body')}</BodyText>,
};

const successData = {
  headerImageSource: <Lottie options={successOptions} height={150} width={150} />,
  headerText: getTranslatedString('residentDrawer.success'),
  bodyText: <BodyText>{getTranslatedString('residentDrawer.deleteDrawer.successBody')}</BodyText>,
};

const DeleteDrawer = ({
  residentId,
  leaseId,
  deleteCotenant,
  reloadPageData,
  closeResidentDrawerCallback,
  hideDeleteDrawer,
  getTenant,
  loading,
  setLoading,
  closeResidentDrawer,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const processOptInOptOutLead = async () => {
    setLoading(true);
    try {
      await deleteCotenant(leaseId, residentId);
      reloadPageData();
      getTenant(residentId, { all_maintenance_tickets: true }); // retrieves data for this drawer
      setShowSuccess(true);
    } catch (e) {
      // TODO: need designs
    }
    setLoading(false);
  };

  let drawerData = {
    ...deleteData,
    cta: (
      <AntdButton
        type="primary"
        label={getTranslatedString('residentDrawer.deleteDrawer.confirm')}
        onClick={processOptInOptOutLead}
        style={primaryButtonColors}
      />
    ),
    secondaryCta: (
      <AntdButton
        type="link"
        label={getTranslatedString('residentDrawer.deleteDrawer.cancel')}
        onClick={hideDeleteDrawer}
        style={buttonColors}
      />
    ),
  };

  if (loading) {
    drawerData = loadingData;
  }

  if (showSuccess) {
    drawerData = {
      ...successData,
      cta: (
        <AntdButton
          type="primary"
          label={getTranslatedString('residentDrawer.close')}
          onClick={() => {
            hideDeleteDrawer();
            closeResidentDrawer();
            closeResidentDrawerCallback();
          }}
          style={primaryButtonColors}
        />
      ),
    };
  }

  return <DrawerMessage {...drawerData} />;
};

export default connect(
  store => ({
    showOptOutResident: store.landlord.residentDrawer.showOptOutResident,
    loading: store.landlord.residentDrawer.loading,
  }),
  {
    hideDeleteDrawer,
    optOutLead,
    optInLead,
    getTenant,
    deleteCotenant,
    setLoading,
    closeResidentDrawer,
  }
)(DeleteDrawer);
